import { Helmet } from 'react-helmet';

interface ViewComponentProps {
  title?: string;
}

const ViewComponent = ({ title }: ViewComponentProps) => (
  <Helmet>
    <title>{`Ideal4Finance | Dashboard${title ? ` | ${title}` : ''}`}</title>
  </Helmet>
);

ViewComponent.displayName = 'Helmet-view';

ViewComponent.defaultProps = {
  title: undefined,
};

export default ViewComponent;
